import * as React from 'react';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { OverflowDropdownButton } from '../../uiComponents/input/Buttons';
import { DropdownButtonItemCallback } from '../../uiComponents/bootstrap-components/BootstrapComponents';

export interface KonkurrenceTilInstitutionUdenLaererTableProps {
    tilmeldLaererTilKonkurrence: (id: string) => void;
    konkurrencer?: any[];
}

export default class KonkurrenceTilInstitutionUdenLaererTable extends React.Component<KonkurrenceTilInstitutionUdenLaererTableProps, any> {
    constructor(props: KonkurrenceTilInstitutionUdenLaererTableProps) {
        super(props);

        this.rowButtons = this.rowButtons.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    ekstraLaerereFormatter(cell: any, row: any) {
        if (cell === undefined) {
            return '';
        } else {
            return cell.join(', ');
        }
    }

    rowButtons(cell: any, row: any) {
        return (
            <div className='table-controls'>
                <OverflowDropdownButton>  
                    <DropdownButtonItemCallback onClick={() => this.props.tilmeldLaererTilKonkurrence(row.tilmeldingId)} text='Tilknyt som ekstra lærer' />
                </OverflowDropdownButton>
            </div>
        );
    }

    render() {
        return (
            <Table data={this.props.konkurrencer} emptyText='Du er tilmeldt alle konkurrencer tilknyttet din institution'>
                <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                <TableHeaderColumn dataField='tilmeldingId' hidden={true} dataAlign='center' />
                <TableHeaderColumn width='100' dataField='dato' className='first' columnClassName='first' dataFormat={TableFormatters.dateFormatter} dataSort={true}>Dato</TableHeaderColumn>
                <TableHeaderColumn dataField='skole' dataSort={true}>Skole</TableHeaderColumn>
                <TableHeaderColumn width='100' dataField='hold' dataSort={true}>Hold</TableHeaderColumn>
                <TableHeaderColumn dataField='konkurrenceTitel' dataSort={true}>Konkurrence</TableHeaderColumn>
                <TableHeaderColumn dataField='ansvarligLaerer' dataSort={true}>Ansvarlig lærer</TableHeaderColumn>
                <TableHeaderColumn dataField='ekstraLaerere' dataFormat={this.ekstraLaerereFormatter} dataSort={true}>Ekstra lærere</TableHeaderColumn>
                <TableHeaderColumn width='75' dataFormat={this.rowButtons} className='table-menu' columnClassName='table-menu' />
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceTilInstitutionUdenLaererTable.tsx